export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref15121.480ebee3.jpg";